mutation enqueuePdfGeneration($valuationId: ID!) {
  enqueuePdfGeneration(valuationId: $valuationId)
}
